module.exports = Object.freeze({
  STATUS_NUMBER: "status_number",
  STATUS_TEXT: "status_text",
  REASON_CODE_NUMBER: "reason_code_number",
  REASON_CODE_TEXT: "reason_code_text",
});
